import styled from "styled-components";
import { color } from "shared/utils/styles";

export const PageLayout = styled.div`
  width: 100%;
  margin-top: 2rem;
  background-color: #fff;
  padding: 0.5rem;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
`;

export const TableContainer = styled.div`
  /* margin-top: 0.2rem; */
  min-height: 12vh;
  max-height: 70vh;
  overflow-y: scroll;
  padding: 0.6rem;
`;

export const TableHeader = styled.div`
  background-color: ${color.fountainLight};
  display: flex;
  width: 100%;
  padding: 1rem 0.2rem;
  justify-content: space-between;
  color: ${color.fountain};
  font-size: 14px;
`;

export const TableRow = styled.div`
  display: flex;
  width: 100%;
  padding: 1rem 0.2rem;
  justify-content: space-between;
  color: ${color.fountain};
  font-size: 14px;
  border: 1px solid ${color.backgroundMedium};
  cursor: pointer;

  &:hover {
    background-color: ${color.backgroundLightest};
  }
`;

export const TableContent = styled.div`
  width: 15%;
  padding-left: 0.2rem;
  justify-content: center;
`;
export const TableContentMain = styled.div`
  width: 15%;
  padding-left: 0.2rem;
  justify-content: center;
  font-size: 13px;
`;

export const TicketIDBadge = styled.span`
  cursor: pointer;
  background: rgba(217, 217, 217, 0.42);
  border-radius: 30px;
  padding: 10px 15px;
`;
